import React from 'react';
import { FormSection } from '../../../components';
import { useCurrentUser } from '../../../shared/currentUser';

export default function BulkDownloadDocumentsEmailConfirmation({ formik }) {
  const currentUser = useCurrentUser();
  const totalDocuments = formik?.values?.documentIds?.length || 0;
  const totalInsureds = formik?.values?.insuredIds?.length || 0;

  return !!currentUser?.email ? (
    <FormSection title="Confirm Download">
      <div className="pt-5 pb-5 pl-5">
        <p>
          You are about to download <b>{totalDocuments}</b> documents for <b>{totalInsureds}</b> insureds.
        </p>
        <p>Your documents will be prepared and compressed. Once ready, a download link will be sent to:</p>
        <p>
          <b>{currentUser?.email}</b>
        </p>
        <p className="text-muted">
          This may take some time for large selections. You can continue working while your documents are being
          prepared.
        </p>
      </div>
    </FormSection>
  ) : (
    <div className="pt-5 pb-5 pl-5">
      <p>We have no email on file for you. Update the email on your account to proceed.</p>
    </div>
  );
}
